import { render, staticRenderFns } from "./box1.vue?vue&type=template&id=1d4881be&scoped=true"
import script from "./box1.vue?vue&type=script&lang=js"
export * from "./box1.vue?vue&type=script&lang=js"
import style0 from "./box1.vue?vue&type=style&index=0&id=1d4881be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4881be",
  null
  
)

export default component.exports